export enum ApplicationsConstants {
  MULTI_CONNECT = 'multi_connect',
  CONNECT_ONE = 'connect_one',
  MOT_ESSENTIAL = 'mot_essential',
  MOT_BUSINESS = 'mot_business',
  MOT_ENTERPRISE = 'mot_enterprise',
  MOT_PAY = 'mot_pay',
  LORAWAN = 'lorawan',
  ACCESS = 'access',
  SUPPORT = 'support',
  FINANCIAL = 'financial',
  SMS = 'sms',
  INDICATORS = 'indicators',
  API = 'my-api',
}

export const ProductsConstants = {
  MULTI_CONNECT: ApplicationsConstants.MULTI_CONNECT,
  CONNECT_ONE: ApplicationsConstants.CONNECT_ONE,
  MOT_ESSENTIAL: ApplicationsConstants.MOT_ESSENTIAL,
  MOT_BUSINESS: ApplicationsConstants.MOT_BUSINESS,
  MOT_ENTERPRISE: ApplicationsConstants.MOT_ENTERPRISE,
  MOT_PAY: ApplicationsConstants.MOT_PAY,
  LORAWAN: ApplicationsConstants.LORAWAN,
};

export const DefaultApplicationsConstants = {
  ACCESS: ApplicationsConstants.ACCESS,
  SUPPORT: ApplicationsConstants.SUPPORT,
  FINANCIAL: ApplicationsConstants.FINANCIAL,
  SMS: ApplicationsConstants.SMS,
  INDICATORS: ApplicationsConstants.INDICATORS,
};

export const motProducts = [
  ApplicationsConstants.MOT_ESSENTIAL,
  ApplicationsConstants.MOT_BUSINESS,
  ApplicationsConstants.MOT_ENTERPRISE,
  ApplicationsConstants.MOT_PAY,
];
